import React,{Component} from 'react';  
import {Modal} from 'react-bootstrap'; 
import {Link} from 'react-router-dom'; 

export class SearchModal extends Component {  
  
  constructor(){
   super();
   this.state={
      show:false
   }
  }
  handleModal()
  {
   this.setState({show: !this.state.show})
  }

 render() {     

   return (  
   <div className="container">  
    <div className="row">  
       <div className="col-sm-12">
    <p onClick={() => this.handleModal()} className="filtericon"><i className="fas fa-search"></i> Search</p>
    </div>
    </div>
    <Modal show={this.state.show} onHide={() => this.handleModal()} size="lg">
      <Modal.Header closeButton>
       <p className="refine-head-txt"><i className="fas fa-filter"></i> Refine</p>
      </Modal.Header>
      <form>
      <Modal.Body>
      
      <div className="row">
               <div className="col-sm-12">
                  <div className="refine-area">
                     <div className="refine-padding">
                        <div className="row">
                           <div className="col-sm-12">
                              <label className="refine-lbl">Type of Rate</label>
                           </div>   
                           <div className="col-sm-2">
                              <input type="text" name="" className="refine-field" placeholder="Standard"/> 
                           </div>
                           <div className="col-sm-2">
                              <input type="text" name="" className="refine-field" placeholder="Tax-free ISA"/>   
                           </div>
                           <div className="col-sm-2">
                              <input type="text" name="" className="refine-field" placeholder="Both"/>  
                           </div>
                        </div>
                        <div className="row">
                           <div className="col-sm-12">
                              <label className="refine-lbl">Interest Payable </label>
                           </div>   
                           <div className="col-sm-2">
                              <input type="text" name="" className="refine-field" placeholder="All"/>   
                           </div>
                           <div className="col-sm-2">
                              <input type="text" name="" className="refine-field" placeholder="Annually"/> 
                           </div>
                           <div className="col-sm-2">
                              <input type="text" name="" className="refine-field" placeholder="Monthly"/>  
                           </div>
                           <div className="col-sm-2">
                              <input type="text" name="" className="refine-field" placeholder="On Maturity"/> 
                           </div>
                        </div>
                        <div className="row">
                           <div className="col-sm-12">
                              <label className="refine-lbl">Sorting By </label>
                           </div>   
                           <div className="col-sm-2">
                              <input type="text" name="" className="refine-field" placeholder="Rate"/>  
                           </div>
                           <div className="col-sm-2">
                              <input type="text" name="" className="refine-field" placeholder="Name"/>  
                           </div>
                        </div>
                        <div className="row">
                           <div className="col-sm-12">
                              <label className="refine-lbl">Providers </label>
                           </div>   
                           <div className="col-sm-4">
                              <select className="refine-field"> 
                                 <option>Select Providers</option>
                              </select>
                           </div>
                        </div>
                        <div className="row">
                           <div className="col-sm-12">
                              <h4 className="refine-title pt-4">Fixed Rate Bond</h4>
                              <label className="refine-lbl">Term </label>
                           </div>   
                           <div className="col-sm-2">
                              <input type="text" name="" className="refine-field" placeholder="All"/>   
                           </div>
                           <div className="col-sm-2">
                              <input type="text" name="" className="refine-field" placeholder="Up to 1 year"/>   
                           </div>
                           <div className="col-sm-2">
                              <input type="text" name="" className="refine-field" placeholder="1 to 3 years"/>   
                           </div>
                           <div className="col-sm-2">
                              <input type="text" name="" className="refine-field" placeholder="3 to 5 years"/>   
                           </div>
                           <div className="col-sm-2">
                              <input type="text" name="" className="refine-field" placeholder="Above 5 Years"/>  
                           </div>
                        </div>
                        <div className="row">
                           <div className="col-sm-12">
                              <h4 className="refine-title pt-4">Notice Account</h4>
                              <label className="refine-lbl">Term </label>
                           </div>   
                           <div className="col-sm-2">
                              <input type="text" name="" className="refine-field" placeholder="All"/>   
                           </div>
                           <div className="col-sm-2">
                              <input type="text" name="" className="refine-field" placeholder="Up to 45 Days"/>  
                           </div>
                           <div className="col-sm-2">
                              <input type="text" name="" className="refine-field" placeholder="46 to 100 Days"/> 
                           </div>
                           <div className="col-sm-2">
                              <input type="text" name="" className="refine-field" placeholder="Above 100 Days"/> 
                           </div>
                        </div>
                     </div>
                  </div>   
               </div>
              </div>

      </Modal.Body>
      <Modal.Footer>

         <div className="d-flex justify-content-end">
               <button className="revise-btn" onClick={() => this.handleModal()}>Revise Search</button>
               <Link to={'/'} className="reset-btn" onClick={() => this.handleModal()}>Reset Search </Link>
               <Link to={'/'} className="cancel-btn" onClick={() => this.handleModal()}>Cancel</Link>
            </div>

      </Modal.Footer>
      </form>
    </Modal>
 </div> 
 
          )  
        }  
      }  
        
export default SearchModal;